export const CONTROLLED_INPUT_DEFAULT_VALUE = ""
export const EMPTY_PLACEHOLDER = "-"
export const DEFAULT_DEBOUNCE_DELAY_IN_MS = 300

export const IS_SENTRY_ENABLED = false

export const STALE_TIME_TEN_MINUTES_IN_MS = 10 * 60 * 1000
export const STALE_TIME_FIVE_MINUTES_IN_MS = 5 * 60 * 1000
